import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../../../api.service";
import { NgForm } from "@angular/forms";
import { CommonService } from "../../../shared/common.service";
import { HostListener } from "@angular/core";

@Component({
  selector: "app-baseline-visits",
  templateUrl: "./baseline-visits.component.html",
  styleUrls: ["./baseline-visits.component.scss"],
})
export class BaselineVisitsComponent implements OnInit {
  @ViewChild("form") form!: NgForm;
  queryParams: any = {};
  formName: string | null = null;
  formData: any = {
    baselineDate: "",
    prakritiAnalysis: "",
    prakritiType: "",
    prakritiComment: "",
    recruited: "",
    recruitmentNo: "",
    recruitmentDate: "",
    vitalSigns: "",
    vitalSignsComments: "",
  };
  //query code
  tabs = [
    { title: "Query", type: "query" },
    { title: "Field History", type: "fieldHistory" },
  ];

  fieldHistoryData: any[] = [];
  selectedTab = 0;
  isOptionsModalOpen = false;
  isModalOpen = false;
  queryText = "";
  // closeQuery = false;
  auditTrail: {
    user: string;
    role: string;
    timestamp: string;
    message: string;
  }[] = [];
  queries: {
    threadId: string;
    text: string;
    isClosed: boolean;
    auditTrail: {
      user: string;
      role: string;
      timestamp: string;
      message: string;
    }[];
  }[] = [
    {
      threadId: this.generateThreadId(),
      text: "",
      isClosed: false,
      auditTrail: [],
    },
  ];
  selectedOption = "query"; // Default to Query section
  showReviewModal = false;
  query: { auditTrail: any };
  fieldLabel: string | null = null; // Add this at the top
  // query code end

  //edit thing
   isBaselineDateDisabled: boolean = false;
  isSubjectRecruitedDisabled: boolean = false;
  isPrakritiAnalysisDisabled: boolean = false;
  isVitalSignsDisabled: boolean = false;
  isPhysicalExamDisabled: boolean = false;
  isLMPDateDisabled: boolean = false;
  isUPTDoneDisabled: boolean = false;
  isUPTResultDisabled: boolean = false;
  isLabDisabled: boolean = false;
  isWeightDisabled: boolean = false;
  isHeightDisabled: boolean = false;
  isWaistDisabled: boolean = false;
  isBMIDisabled: boolean = false;
  isDietDisabled: boolean = false;
  isLifestyleDisabled: boolean = false;
  isSignatureDisabled: boolean = false;
  isDateDisabled: boolean = false;
  isAdverseDisabled: boolean = false;
  isAdverseDisabled2: boolean = false;
isADT1Disabled:boolean=false;
isADT2Disabled:boolean=false;
isADT3Disabled:boolean=false;
isStudyProductsDisabled:boolean=false;
isProductConsumptionGuideDisabled:boolean=false;
isProductLogDisabled:boolean=false;
isDispensingDateDisabled:boolean=false;
isAsanaSachetsDisabled:boolean=false;
isAsanaQuantityDisabled:boolean=false;
isAsanaBatchDisabled:boolean=false;
isAsanaExpiryDisabled:boolean=false;
isDietaryGuidelinesDisabled:boolean=false;
isLifestyle2Disabled:boolean=false;
isTriphalaSachetsDisabled:boolean=false;
isTriphalaQuantityDisabled:boolean=false;
isTriphalaBatchDisabled:boolean=false;
isTriphalaExpiryDisabled:boolean=false;
isYavaSachetsDisabled:boolean=false;
isYavaQuantityDisabled:boolean=false;
isYavaBatchDisabled:boolean=false;
isYavaExpiryDisabled:boolean=false;




  // isConsentDisabled: boolean = false;
  // isAnalysisDisabled: boolean = false;
  // isLanguageDisabled: boolean = false;

  // // isDatePickerDisabled2: boolean = false;
  // // isDatePickerDisabled3: boolean = false;
  // isTimePickerDisabled: boolean = false;
  // isAgeDisabled: boolean = false;
  // isGenderDisabled: boolean = false;

  isReasonModalOpen: boolean = false;
  editReason: string = "";

  currentYear = new Date().getFullYear();
  screeningDateMin: string;
  // Mapping for each form: question text to formData field
  prakritiOptions: string[] = [
    "Vāta",
    "Pitta",
    "Kapha",
    "Sama",
    "Vāta-Pitta",
    "Pitta-Vāta",
    "Kapha-Vāta",
    "Vāta-Kapha",
    "Pitta-Kapha",
    "Kapha-Pitta",
  ];
  private questionMapping: {
    [key: string]: { question: string; field: string }[];
  } = {
    "baseline-record": [
      { question: "1. Date of the Baseline Visit:", field: "baselineDate" },
      { question: "2. Was the subject recruited", field: "recruited" },
    ],
    "baseline-prakriti-analysis": [
      {
        question: "1. Was the prakriti analysis done for the subject",
        field: "prakritiAnalysis",
      },
    ],

    "baseline-vital-signs": [
      {
        question: "1. Was Vital Signs evaluation performed",
        field: "vitalSigns",
      },
    ],
    "baseline-physical-exam": [
      {
        question: "1. Was physical and systemic examination performed",
        field: "physicalExam",
      },
    ],
    // 'baseline-pregnancy-declaration': [
    //   { question: '1. Ask the subject “Are you currently pregnant?', field: 'pregnancyStatus' }
    // ],
    "baseline-pregnancy-declaration": [
      { question: "Date of Last Menstrual Period (LMP)", field: "lmpDate" },
      { question: "Was Urine Pregnancy Test (UPT) done", field: "uptDone" },
      { question: "UPT Result", field: "uptResult" },
    ],
    "baseline-lab-investigation": [
      {
        question: "1. Was Laboratory Investigation performed",
        field: "labInvestigation",
      },
    ],
    "baseline-anthropometric-data": [
      { question: "1. Weight:", field: "weight" },
      { question: "2. Height:", field: "height" },
      {
        question: "3. Waist circumference (part of IDRS Assessment):",
        field: "waistCircumference",
      },
      {
        question: "4. Body Mass Index [BMI = Weight (kg)/ Height2 (m)]:",
        field: "bmi",
      },
    ],
    "baseline-diet-assessment": [
      {
        question:
          "1. Was the Diet Assessment done using the 24-Hour Diet Recall Checklist",
        field: "dietAssessment",
      },
    ],
    "baseline-lifestyle-assessment": [
      {
        question:
          "1. Was the Lifestyle Assessment done using the FANTASTIC Lifestyle Checklist",
        field: "lifestyleAssessment",
      },
    ],
    "baseline-intervention-details": [
      {
        question: "1. ADT - Ayurveda Diet Therapy: Health drink - asana pānaka",
        field: "adtHealthDrink",
      },
      {
        question: "2. ADT - Ayurveda Diet Therapy: Triphala tablets",
        field: "adtTriphalaTablets",
      },
      {
        question: "3. ADT - Ayurveda Diet Therapy: Dietary guidelines",
        field: "adtDietaryGuidelines",
      },
      {
        question:
          "4. ABLI - Ayurveda Behavioural Lifestyle Intervention: Udvartana",
        field: "abliUdvartana",
      },
      {
        question:
          "5. ABLI - Ayurveda Behavioural Lifestyle Intervention: Lifestyle guidelines",
        field: "abliLifestyleGuidelines",
      },
    ],
    "baseline-product-dispensing": [
      {
        question:
          "1. Were all the Study Products dispensed to the subject as per protocol",
        field: "studyProductsDispensed",
      },
      {
        question: "2. Was the Product Consumption Guide given to the patient",
        field: "productConsumptionGuide",
      },
      {
        question:
          "3. Was the Daily Product Consumption Log given to the subject",
        field: "dailyProductConsumptionLog",
      },
      {
        question: "4. Date of dispensing of the Study Products",
        field: "studyProductsDispensingDate",
      },

      // Asana Churna herbal drink fields
      { question: "i. Asana Churna herbal drink", field: "asanaChurna" },
      {
        question: "1. Total Number of sachets/boxes dispensed in this visit:",
        field: "asanaChurnaQuantity",
      },
      {
        question: "2. Total Study Product quantity dispensed in this visit:",
        field: "asanaChurnaQuantityDispensed",
      },
      { question: "3. Batch Number:", field: "asanaChurnaBatchNo" },
      { question: "4. Date of Expiry:", field: "asanaChurnaExpiryDate" },

      // Triphala tablet fields
      { question: "ii. Triphala tablet", field: "triphalaTablet" },
      {
        question: "1. Total Number of sachets/boxes dispensed in this visit:",
        field: "triphalaSachets",
      },
      {
        question: "2. Total Study Product quantity dispensed in this visit:",
        field: "triphalaQuantity",
      },
      { question: "3. Batch Number:", field: "triphalaBatchNumber" },
      { question: "4. Date of Expiry:", field: "triphalaExpiryDate" },

      // Yava Churna fields
      { question: "iii. Yava Churna", field: "yavaChurna" },
      {
        question: "1. Total Number of sachets/boxes dispensed in this visit:",
        field: "yavaChurnaQuantity",
      },
      {
        question: "2. Total Study Product quantity dispensed in this visit:",
        field: "yavaChurnaQuantityDispensed",
      },
      { question: "3. Batch Number:", field: "yavaChurnaBatchNo" },
      { question: "4. Date of Expiry:", field: "yavaChurnaExpiryDate" },

      // Dietary and Lifestyle Guidelines
      {
        question:
          "1. Was the dietary consumption guidelines document given to the subject",
        field: "dietaryGuidelines",
      },
      {
        question:
          "2. Was the lifestyle guidelines document given to the subject",
        field: "lifestyleGuidelines",
      },
    ],
    // For Baseline Adverse Events
    "baseline-adverse-events": [
      {
        question:
          "1. Did the subject experience any adverse event since last visit",
        field: "adverseEvents",
      },
      {
        question:
          "2. Did the subject take any new or change in concomitant medications since last visit",
        field: "concomitantMedications",
      },
    ],

    // For End of Baseline Visit
    "baseline-end-visit": [
      {
        question: "1. Principal Investigator’s Signature:",
        field: "investigatorSignature",
      },
      { question: "2. Date:", field: "endBaselineVisitDate" },
    ],
  };
  folderName: any;
  studyId: any;
  subjectId: any;
  studyCode: any;
  studyName: any;
  subjectName: any;
  siteLocation: any;
  todayDate: string;
  informedConsentDate: string;
  screeningMinDate: string;
  gender: any;
  asanaChurnaQuantity: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    const userData = this.commonService.getUserData();
    console.log("User Data from Cookie:", userData);

    const isLoggedIn = this.commonService.isLoggedIn();
    console.log("Is Logged In:", isLoggedIn);

    console.log("ngOnInit Executed");
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = today.getFullYear();
    this.todayDate = `${year}-${month}-${day}`;

    this.informedConsentDate = ""; // Start with an empty value
    this.screeningMinDate = ""; // Same for screeningMinDate

    this.route.params.subscribe((params) => {
      this.folderName = params["folderName"] ?? "baseline-visits";
      this.formName = params["formName"];
      console.log("Form Name:", this.formName);
      this.checkAndCallApi();
    });

    this.route.queryParams.subscribe((queryParams) => {
      this.studyId = queryParams["studyId"];
      this.subjectId = queryParams["subjectId"];
      this.checkAndCallApi();
    });
    console.log("Extracted Params:", {
      studyId: this.studyId,
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName,
    });
  }

  checkAndCallApi() {
    if (this.studyId && this.subjectId && this.folderName && this.formName) {
      console.log("Calling API getFormData...");
      this.apiService
        .getFormData(
          this.studyId,
          this.subjectId,
          this.folderName,
          this.formName
        )
        .subscribe({
          next: (response) => {
            console.log("Fetched Form Data:", response);
            if (response.success) {
              // Ensure response.data is an array before mapping
              if (Array.isArray(response.data)) {
                this.mapFormData(response.data);
              } else {
                console.warn("Form data is not an array or is missing.");
              }
              this.mapStudyDetails(response.studyDetails);

              // Dynamically update informedConsentDate from the response
              if (response.informedConsentDate !== undefined) {
                this.informedConsentDate = response.informedConsentDate;
                this.screeningMinDate = this.informedConsentDate; // Set min date
                console.log("Informed Consent Date:", this.informedConsentDate);
              } else {
                console.warn(
                  "Informed consent date is missing in the response."
                );
              }

              // Store the gender from the response
              this.gender = response.gender;
              console.log("gender:", this.gender);
            }
          },
          error: (error) => {
            console.error("Error fetching form data:", error);
          },
        });
      // const fieldName = '2. Date of Study Completion:';
      const fieldName = this.fieldLabel || "Unknown Field";
      this.apiService
        .getInsertHistoryData(
          this.studyId,
          this.subjectId,
          this.folderName,
          this.formName,
          fieldName
        )
        .subscribe({
          next: (response) => {
            console.log("Fetched Field History for", fieldName, response);
            this.fieldHistoryData = response.data || [];
          },
          error: (error) => {
            console.error("Error fetching field history data:", error);
          },
        });
    } else {
      console.error(
        "Missing required parameters: studyId, subjectId, folderName, or formName."
      );
    }
  }

  addTab(label: string = "Date of Study Completion") {
    const fieldName = label.trim(); // You can enhance this mapping if needed

    this.apiService
      .getInsertHistoryData(
        this.studyId,
        this.subjectId,
        this.folderName,
        this.formName,
        fieldName
      )
      .subscribe({
        next: (response) => {
          console.log("Fetched Field History for", fieldName, response);
          this.fieldHistoryData = response.data || [];

          // Add tab only after fetching data
          this.tabs.push({ title: "Field History", type: "fieldHistory" });
          this.selectedTab = this.tabs.length - 1;
        },
        error: (error) => {
          console.error("Error fetching field history data:", error);
        },
      });
  }

  generateThreadId(): string {
    return "thread-" + Math.random().toString(36).substr(2, 9);
  }

  selectTab(index: number) {
    this.selectedTab = index;
    const selected = this.tabs[index];
    if (selected.type === "query") {
      // const fieldName = '2. Date of Study Completion:'; // Or dynamically set based on tab
      const fieldName = this.fieldLabel || "Unknown Field";
      console.log("Fetching Query History for Field:", fieldName); // <-- Add this
      this.apiService
        .getQueryHistoryData(
          this.studyId,
          this.subjectId,
          this.folderName,
          this.formName,
          fieldName
        )
        .subscribe({
          next: (response) => {
            console.log("Fetched Query History Data:", response);
            // You can decide how to display this – either integrate it into the auditTrail or a dedicated UI block
            // Example: populate audit trails per query
            if (response.data && Array.isArray(response.data)) {
              const auditTrail = response.data.map((item: any) => {
                const subData = item.sub_data ? JSON.parse(item.sub_data) : {};
                return {
                  user: item.updated_by || "Unknown",

                  timestamp: subData.timestamp || item.updated_at,
                  message: item.value || "",
                };
              });
            }
          },
          error: (error) => {
            console.error("Error fetching query history data:", error);
          },
        });
    }
    if (selected.type === "fieldHistory") {
      const fieldName = this.fieldLabel || "Unknown Field";
      console.log("Fetching Field History for:", fieldName);
      this.apiService
        .getInsertHistoryData(
          this.studyId,
          this.subjectId,
          this.folderName,
          this.formName,
          fieldName
        )
        .subscribe({
          next: (response) => {
            console.log("Fetched Field History Data:", response);
            this.fieldHistoryData = response.data || [];
          },
          error: (error) => {
            console.error("Error fetching field history data:", error);
          },
        });
    }
  }

  closeTab(index: number, event: MouseEvent) {
    event.stopPropagation();
    this.tabs.splice(index, 1);
    if (this.selectedTab >= this.tabs.length) {
      this.selectedTab = this.tabs.length - 1;
    }
  }
  openReviewModal() {
    this.showReviewModal = true;


  const fieldName = this.fieldLabel || 'Unknown Field';
  console.log('Opening Review Modal - Fetching Field History for:', fieldName);

  this.apiService.getInsertHistoryData(
    this.studyId,
    this.subjectId,
    this.folderName,
    this.formName,
    fieldName
  ).subscribe({
    next: (response) => {
      console.log('Fetched Field History Data (from review modal):', response);
      this.fieldHistoryData = response.data || [];

      // Initialize default review flags
      let latestReview = {
        dataMonitor: false,
        monitor: false,
        pi: false
      };

      // Sort descending by updated_at to get the latest ones first
      const sortedData = [...this.fieldHistoryData].sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());

      const flagsFound = {
        dataMonitor: false,
        monitor: false,
        pi: false
      };

      for (const entry of sortedData) {
        if (!entry.review_status) continue;

        try {
          const parsed = JSON.parse(entry.review_status);

          // For each reviewer type, only update if not already found (i.e., get the latest one)
          if (!flagsFound.dataMonitor && parsed.hasOwnProperty('dataMonitor')) {
            latestReview.dataMonitor = parsed.dataMonitor;
            flagsFound.dataMonitor = true;
          }

          if (!flagsFound.monitor && parsed.hasOwnProperty('monitor')) {
            latestReview.monitor = parsed.monitor;
            flagsFound.monitor = true;
          }

          if (!flagsFound.pi && parsed.hasOwnProperty('pi')) {
            latestReview.pi = parsed.pi;
            flagsFound.pi = true;
          }

          // If all found, stop early
          if (flagsFound.dataMonitor && flagsFound.monitor && flagsFound.pi) {
            break;
          }

        } catch (err) {
          console.error("Error parsing review_status JSON:", err);
        }
      }

      this.reviewOptions = latestReview;
      console.log("✅ Final reviewOptions applied:", this.reviewOptions);
    },

    error: (error) => {
      console.error('Error fetching field history data from review modal:', error);
    }
  });
  }

  closeReviewModal() {
    this.showReviewModal = false;
  }

  openOptionsModal(event: MouseEvent, target: EventTarget | null) {
    event.stopPropagation();
    this.isOptionsModalOpen = true;

    // Traverse to the closest parent with `data-label`
    const icon = target as HTMLElement;
    const fieldGroup = icon.closest(".form-group");

    if (fieldGroup) {
      this.fieldLabel = fieldGroup.getAttribute("data-label");
      console.log("Dynamically captured label:", this.fieldLabel);
    }
  }

  openModal() {
    this.isModalOpen = true;
    this.selectedTab = 0; // Default to 'Query'

    // const fieldName = '2. Date of Study Completion:'; // Or dynamically get it
    const fieldName = this.fieldLabel || "Unknown Field";
    console.log("Opening modal - Fetching field name:", fieldName); // <-- Add this

    this.apiService
      .getQueryHistoryData(
        this.studyId,
        this.subjectId,
        this.folderName,
        this.formName,
        fieldName
      )
      .subscribe({
        next: (response) => {
          console.log("Fetched Query History Data:", response);

          if (response.success && Array.isArray(response.data)) {
            this.queries = response.data.map((entry: any) => {
              const auditTrail =
                entry.auditTrail?.map((a: any) => ({
                  user: a.user,
                  timestamp: a.timestamp,
                  message:
                    typeof a.message === "string"
                      ? a.message
                      : String(a.message),
                })) || [];

              const isClosed = auditTrail.some(
                (item) =>
                  typeof item.message === "string" &&
                  item.message.toLowerCase().includes("query closed")
              );

              const query = {
                selectedField: entry.auditTrail?.[0]?.selectedField || '',
                threadId: entry.threadId || "no-thread",
                text: this.getInitialQueryText(auditTrail) || "",
                isClosed: isClosed,
                auditTrail: auditTrail,
              };

              return query;
            });
          } else {
            // Fallback for empty or invalid data
            this.queries = Array(3)
              .fill(null)
              .map(() => ({
                 selectedField: null,
                threadId: this.generateThreadId(),
                text: "",
                isClosed: false,
                auditTrail: [],
              }));
          }
        },
        error: (error) => {
          console.error("Error fetching query history:", error);
          this.queries = [
            {
              
              threadId: this.generateThreadId(),
              text: "",
              isClosed: false,
              auditTrail: [],
            },
          ];
        },
      });
  }

  getInitialQueryText(auditTrail: any[]): string {
    if (!Array.isArray(auditTrail)) return "";

    // Look for latest message or first valid message in each query's auditTrail
    const validEntry = auditTrail
      .filter(
        (a) =>
          typeof a.message === "string" &&
          a.message.trim() &&
          a.message.toLowerCase() !== "query closed"
      )
      .pop(); // or use [0] for first message

    return validEntry ? validEntry.message : "";
  }

  closeModal() {
    this.isModalOpen = false;
    document.body.classList.remove("modal-open");
  }

  addQuery(index: number) {
    
    this.queries.splice(index + 1, 0, {
      threadId: this.generateThreadId(),
      text: "",
      isClosed: false,
      auditTrail: [],
    });
  }
  submitQuery(index: number) {
    const userData = this.commonService.getUserData(); // Extract from cookies
    console.log("userData:", userData); // Check the structure
    const fullName = `${userData.first_name} ${userData.last_name}`;
    const designation = userData.designation || "N/A"; // Fallback if not available

    const timestamp = new Date().toISOString(); // ISO format for backend

    const query = this.queries[index];

    if (!query.text || !query.text.trim()) {
      console.warn("No text entered for this query. Ignoring submit.");
      return;
    }

    // Ensure threadId
    if (!query.threadId) {
      query.threadId = this.generateThreadId();
    }

    const payloadItem = {
      studyId: this.studyId,
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName,
      // fieldName: '2. Date of Study Completion:',
      fieldName: this.fieldLabel || "Unknown Field",
      threadId: query.threadId,
      queryText: query.text.trim(),
      user: fullName,
      designation: designation,
      timestamp: timestamp,
    };
    console.log("Submitting Query Payload:", payloadItem); // <-- Important log

    this.apiService.submitQueryData([payloadItem]).subscribe({
      next: (response) => {
        console.log("Query submitted:", response);

        query.auditTrail = query.auditTrail || [];
        query.auditTrail.push({
          user: fullName,
          role: designation,
          timestamp: new Date().toLocaleString(),
          message: payloadItem.queryText,
        });
        query.text = ""; // Clear only this one
      },
      error: (error) => {
        console.error("Error submitting query:", error);
      },
    });
  }

  reviewOptions = {
    dataMonitor: false,
    monitor: false,
    pi: false,
  };

  confirmCloseQuery(index: number): void {
    const confirmed = window.confirm(
      "Are you sure you want to close this query?"
    );
    if (confirmed) {
      this.closeQuery(index);
    }
  }
  closeQuery(index: number): void {
    const userData = this.commonService.getUserData();
    const fullName = `${userData.first_name} ${userData.last_name}`;
    const designation = userData.designation || "N/A";
    const timestamp = new Date().toISOString(); // For backend
    const localTime = new Date().toLocaleString(); // For UI

    const query = this.queries[index];
    if (!query.threadId) {
      query.threadId = this.generateThreadId();
    }

    const closeMessage = "Query closed";

    const payloadItem = {
      studyId: this.studyId,
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName,
      // fieldName: '2. Date of Study Completion:',
      fieldName: this.fieldLabel || "Unknown Field",
      threadId: query.threadId,
      queryText: closeMessage,
      user: fullName,
      designation: designation,
      timestamp: timestamp,
      isClosed: true, // Optional, in case your backend expects a flag
    };

    this.apiService.submitQueryData([payloadItem]).subscribe({
      next: (response) => {
        console.log("Query closed:", response);

        query.auditTrail = query.auditTrail || [];
        query.auditTrail.push({
          user: fullName,
          role: designation,
          timestamp: localTime,
          message: closeMessage,
        });
        query.isClosed = true;
        alert("Query closed successfully");
      },
      error: (error) => {
        console.error("Error closing query:", error);
      },
    });
  }
  confirmSubmitQuery(index: number): void {
    const confirmSubmit = confirm("Are you sure you want to submit the data?");
    if (confirmSubmit) {
      this.submitQuery(index);
      alert("Data submitted successfully");
    }
  }

  // Function to map study details
  mapStudyDetails(studyDetails: any): void {
    if (studyDetails) {
      // Check if studyDetails has the expected properties
      this.studyCode = studyDetails.study_code ?? "N/A"; // Default to 'N/A' if study_code is undefined
      this.studyName = studyDetails.study_name ?? "Unknown Study"; // Default to 'Unknown Study' if study_name is undefined
      this.siteLocation = studyDetails.site_location ?? "Unknown Location"; // Default to 'Unknown Location' if site_location is undefined
      this.subjectName = this.subjectId; // Mapping subjectId to subjectName

      console.log("Mapped Study Details:", {
        studyCode: this.studyCode,
        studyName: this.studyName,
        siteLocation: this.siteLocation,
        subjectName: this.subjectName,
      });
    } else {
      console.warn("Study details are missing or undefined.");
    }
  }
 hasBaselineDData=false;
 hasSubjectRecruitedData=false;
 hasPrakritiData=false;
 hasVitalSignData=false;
 hasPhysicalExamData=false;
 hasLMPData=false;
hasUPTData=false;
hasUPTResultData=false;
hasLabInvestigationData =false;
hasWeightData=false;
hasHeightData=false;
hasWaistData=false;
hasBMIData=false;
hasDietData=false;
hasLifestyleData=false;
hasADT1Data=false;
hasADT2Data=false;
hasADT3Data=false;
hasDispensedData=false;
hasGuideData=false;
hasLogData=false;
hasDispensingDData=false;
hasAsanaSachetsData=false;
hasAsanaQuantityData=false;
hasAsanaBatchData=false;
hasAsanaExpiryData=false;
hasTriphalaSachetsData=false;
hasTriphalaQuantityData=false;
hasTriphalaBatchData=false;
hasTriphalaExpiryData=false;
hasLifestyle2Data=false;
hasYavaSachetsData=false;
hasYavaQuantityData =false;
hasYavaBatchData=false;
hasYavaExpiryData=false;
hasDiet2Data=false;
hasAdverseData=false;
hasAdverse2Data=false;
hasPrincipalSignData=false;
hasEndDData=false;


  mapFormData(data: any[]): void {
      this.hasBaselineDData = false;
      this.hasSubjectRecruitedData=false;
      this.hasPrakritiData=false;
      this.hasVitalSignData=false;
      this.hasPhysicalExamData=false;
      this.hasLMPData=false;
      this.hasUPTData=false;
      this.hasUPTResultData=false;
      this.hasLabInvestigationData =false;
      this.hasWeightData=false;
      this.hasHeightData=false;
      this.hasWaistData=false;
      this.hasBMIData=false;
      this.hasDietData=false;
      this.hasLifestyleData=false;
      this.hasADT1Data=false;
      this.hasADT2Data=false;
      this.hasADT3Data=false;
      this.hasDispensedData=false;
      this.hasGuideData=false;
      this.hasLogData=false;
      this.hasDispensingDData=false;
      this.hasAsanaSachetsData=false;
      this.hasAsanaQuantityData=false;
      this.hasAsanaBatchData=false;
this.hasAsanaExpiryData=false;
this.hasTriphalaSachetsData=false;
this.hasTriphalaQuantityData=false;
this.hasTriphalaBatchData=false;
this.hasTriphalaExpiryData=false;
this.hasYavaSachetsData=false;
this.hasYavaQuantityData =false;
this.hasYavaBatchData=false;
this.hasYavaExpiryData=false;
this.hasLifestyle2Data=false;
      this.hasDiet2Data=false;
      this.hasAdverseData=false;
      this.hasAdverse2Data=false;
      this.hasPrincipalSignData=false;
      this.hasEndDData=false;

    data.forEach((item) => {
      const fieldName = item.field_name?.trim(); // Ensure no leading/trailing spaces
      const fieldValue = item.value;
      const isChecked = item.value === "yes";
      // Map checkbox values
    if (fieldName === 'reviewedByDataMonitor') this.reviewOptions.dataMonitor = fieldValue === 'true';
    if (fieldName === 'reviewedByMonitor') this.reviewOptions.monitor = fieldValue === 'true';
    if (fieldName === 'reviewedByPI') this.reviewOptions.pi = fieldValue === 'true';

      switch (fieldName) {
        case "1. Date of the Baseline Visit:":
          this.formData.baselineDate = fieldValue; // Map date field
          this.isBaselineDateDisabled = !!fieldValue;
            this.hasBaselineDData = !!fieldValue;
          break;
        case "1. Was the prakriti analysis done for the subject":
          this.formData.prakritiAnalysis = fieldValue;
          this.hasPrakritiData=!!fieldValue;
          this.isPrakritiAnalysisDisabled = !!fieldValue;
          if (item.sub_data) {
            try {
              const subValue = JSON.parse(item.sub_data);
              if (fieldValue === "yes") {
                this.formData.prakritiType = subValue;
              } else if (fieldValue === "no") {
                this.formData.prakritiComment = subValue;
              }
            } catch (error) {
              console.error("Error parsing Prakriti sub_data:", error);
            }
          }
          break;

        case "2. Was the subject recruited":
          this.formData.recruited = fieldValue;
          this.hasSubjectRecruitedData=!!fieldValue;
          this.isSubjectRecruitedDisabled = !!fieldValue; // Map recruited field
          if (fieldValue === "yes" && item.sub_data) {
            try {
              const subData = JSON.parse(item.sub_data); // Parse sub_data if available
              this.formData.recruitmentNo = subData.recruitmentNo;
              this.formData.recruitmentDate = subData.recruitmentDate;
            } catch (error) {
              console.error("Error parsing sub_data:", error);
            }
          }
          break;
        case "1. Was Vital Signs evaluation performed":
          this.formData.vitalSigns = fieldValue;
          this.isVitalSignsDisabled = !!fieldValue; // Map Yes/No value
          this.hasVitalSignData=!!fieldValue;
          if (fieldValue === "no" && item.sub_data) {
            try {
              this.formData.vitalSignsComments = JSON.parse(item.sub_data); // Parse comment if available
            } catch (error) {
              console.error("Error parsing sub_data:", error);
              this.formData.vitalSignsComments = item.sub_data; // Fallback to raw value
            }
          }
          break;
        case "1. Was physical and systemic examination performed":
          this.formData.physicalExam = fieldValue; // Map Yes/No value
          this.isPhysicalExamDisabled = !!fieldValue;
          this.hasPhysicalExamData=!!fieldValue;
          if (fieldValue === "no" && item.sub_data) {
            try {
              this.formData.physicalExamComments = JSON.parse(item.sub_data); // Parse comment if available
            } catch (error) {
              console.error("Error parsing sub_data:", error);
              this.formData.physicalExamComments = item.sub_data; // Fallback to raw value
            }
          }
          break;
        // case '1. Ask the subject "Are you currently pregnant?"': // Updated to use straight quotes
        // this.formData.pregnancyStatus = fieldValue; // Map Yes/No/NA

        // if (item.sub_data) {
        //   // Store sub_data safely without parsing since it's a string
        //   this.formData.pregnancyDetails = item.sub_data;
        // }
        // break;
        case "Date of Last Menstrual Period (LMP)":
          this.formData.lmpDate = fieldValue;
          this.hasLMPData=!!fieldValue;
          this.isLMPDateDisabled = !!fieldValue; // Store LMP Date
          break;

        case "Was Urine Pregnancy Test (UPT) done":
          this.formData.uptDone = fieldValue; // Store UPT Done (YES/NO)
          this.isUPTDoneDisabled = !!fieldValue;
          this.hasUPTData=!!fieldValue;
          break;

        case "UPT Result":
          this.formData.uptResult = fieldValue;
          this.isUPTResultDisabled = !!fieldValue;
          this.hasUPTResultData=!!fieldValue; // Store UPT Result (Positive/Negative)
          break;
        case "1. Was Laboratory Investigation performed":
          this.formData.labInvestigation = fieldValue; // Map Yes/No
          this.isLabDisabled = !!fieldValue;
          this.hasLabInvestigationData =!!fieldValue;

          if (item.sub_data) {
            // Parse the date from sub_data if available
            try {
              this.formData.sampleCollectionDate = new Date(item.sub_data)
                .toISOString()
                .split("T")[0]; // Format to YYYY-MM-DD
            } catch (error) {
              console.error("Error parsing sample collection date:", error);
              this.formData.sampleCollectionDate = ""; // Fallback if parsing fails
            }
          }
          if (this.formData.labInvestigation === "no" && item.sub_data) {
            this.formData.labInvestigationComments = item.sub_data; // Populate comments if available
          }
          break;
        case "1. Weight:":
          this.formData.weight = fieldValue;
          this.hasWeightData=!!fieldValue;
          this.isWeightDisabled = !!fieldValue; // Map Weight
          break;

        case "2. Height:":
          this.formData.height = fieldValue;
          this.isHeightDisabled = !!fieldValue; // Map Height
          this.hasHeightData=!!fieldValue;
          break;

        case "3. Waist circumference (part of IDRS Assessment):":
          this.formData.waistCircumference = fieldValue; // Map Waist Circumference
          this.isWaistDisabled = !!fieldValue;
          this.hasWaistData=!!fieldValue;
          break;

        case "4. Body Mass Index [BMI = Weight (kg)/ Height2 (m)]:":
          this.formData.bmi = fieldValue; // Map BMI
          this.isBMIDisabled = !!fieldValue;
          this.hasBMIData=!!fieldValue;
          break;
        // Map the "sub_data" for diet assessment comment when needed
        case "1. Was the Diet Assessment done using the 24-Hour Diet Recall Checklist":
          this.formData.dietAssessment = fieldValue; // Map the value for Diet Assessment
          this.isDietDisabled = !!fieldValue;
          this.hasDietData=!!fieldValue;
          if (fieldValue === "no" && item.sub_data) {
            this.formData.dietAssessmentComments = item.sub_data.replace(
              /^"|"$/g,
              ""
            ); // Directly assign sub_data as comment
          }
          break;

        case "1. Was the Lifestyle Assessment done using the FANTASTIC Lifestyle Checklist":
          this.formData.lifestyleAssessment = fieldValue;
          this.isLifestyleDisabled = !!fieldValue;
          this.hasLifestyleData=!!fieldValue;
          if (fieldValue === "no" && item.sub_data) {
            this.formData.lifestyleAssessmentComments = item.sub_data.replace(
              /"/g,
              ""
            ); // Remove quotes
          }
          break;
        case "1. ADT - Ayurveda Diet Therapy: Health drink - asana pānaka":
          this.formData.adtHealthDrink = isChecked;
          this.isADT1Disabled = !!fieldValue;
          this.hasADT1Data=!!fieldValue;
          break;

        case "2. ADT - Ayurveda Diet Therapy: Triphala tablets":
          this.formData.adtTriphalaTablets = isChecked;
          this.isADT2Disabled = !!fieldValue;
          this.hasADT2Data=!!fieldValue;
          break;

        case "3. ADT - Ayurveda Diet Therapy: Dietary guidelines":
          this.formData.adtDietaryGuidelines = isChecked;
          this.isADT3Disabled = !!fieldValue;
          this.hasADT3Data=!!fieldValue;
          break;

        case "4. ABLI - Ayurveda Behavioural Lifestyle Intervention: Udvartana":
          this.formData.abliUdvartana = isChecked;
          break;
        case "5. ABLI - Ayurveda Behavioural Lifestyle Intervention: Lifestyle guidelines":
          this.formData.abliLifestyleGuidelines = isChecked;
          break;
        case "1. Did the subject experience any adverse event since last visit":
          this.formData.adverseEvents = fieldValue;
          this.isAdverseDisabled = !!fieldValue;
          this.hasAdverseData=!!fieldValue; // Map Yes/No
          break;

        case "2. Did the subject take any new or change in concomitant medications since last visit":
          this.formData.concomitantMedications = fieldValue;
          this.isAdverseDisabled2 = !!fieldValue;
          this.hasAdverse2Data=!!fieldValue; // Map Yes/No
          break;
        case "1. Principal Investigator’s Signature:":
          this.formData.investigatorSignature = fieldValue;
          this.isSignatureDisabled = !!fieldValue; 
          this.hasPrincipalSignData=!!fieldValue;// Map Investigator Signature
          break;

        case "2. Date:":
          this.formData.endBaselineVisitDate = fieldValue; // Map Date Field
          this.isDateDisabled = !!fieldValue;
          this.hasEndDData=!!fieldValue;
          break;
        //product
        case "1. Were all the Study Products dispensed to the subject as per protocol":
          this.formData.studyProductsDispensed = fieldValue;
          this.isStudyProductsDisabled = !!fieldValue;
          this.hasDispensedData=!!fieldValue; // Map Yes/No field
          if (fieldValue === "no" && item.sub_data) {
            try {
              this.formData.studyProductsDispensedComments =
                item.sub_data.replace(/^"|"$/g, ""); // Store sub_data as comments
            } catch (error) {
              console.error("Error parsing sub_data:", error);
            }
          }
          break;

        case "2. Was the Product Consumption Guide given to the patient":
          this.formData.productConsumptionGuide = fieldValue;
          this.isProductConsumptionGuideDisabled = !!fieldValue; // Map Yes/No field
          this.hasGuideData=!!fieldValue;
          if (fieldValue === "no" && item.sub_data) {
            try {
              this.formData.productConsumptionGuideComments =
                item.sub_data.replace(/^"|"$/g, ""); // Store sub_data as comments
            } catch (error) {
              console.error("Error parsing sub_data:", error);
            }
          }
          break;

        case "3. Was the Daily Product Consumption Log given to the subject":
          this.formData.dailyProductConsumptionLog = fieldValue; 
           this.isProductLogDisabled = !!fieldValue;// Map Yes/No field
           this.hasLogData=!!fieldValue;
          if (fieldValue === "no" && item.sub_data) {
            try {
              this.formData.dailyProductConsumptionLogComments =
                item.sub_data.replace(/^"|"$/g, ""); // Store sub_data as comments
            } catch (error) {
              console.error("Error parsing sub_data:", error);
            }
          }
          break;

        case "4. Date of dispensing of the Study Products":
          this.formData.studyProductsDispensingDate = fieldValue; 
          this.isDispensingDateDisabled = !!fieldValue;
          this.hasDispensingDData=!!fieldValue;// Map date field
          break;
        case "i. Asana Churna herbal drink":
          if (item.sub_data) {
            let subData = JSON.parse(item.sub_data);
            this.formData.asanaChurnaSachets = subData.sachets || null;
             this.isAsanaSachetsDisabled = !!fieldValue;
             this.hasAsanaSachetsData=!!fieldValue;
            this.formData.asanaChurnaQuantity = subData.quantity || null;
             this.isAsanaQuantityDisabled = !!fieldValue;
              this.hasAsanaQuantityData=!!fieldValue;
            this.formData.asanaChurnaBatchNumber = subData.batchNumber || null;
               this.isAsanaBatchDisabled = !!fieldValue;
                this.hasAsanaBatchData=!!fieldValue;
            this.formData.asanaChurnaExpiryDate = subData.expiryDate || null;
            this.isAsanaExpiryDisabled=!!fieldValue;
             this.hasAsanaExpiryData=!!fieldValue;
           
          }
          break;
        case "ii. Triphala tablet":
          if (item.sub_data) {
            let subData = JSON.parse(item.sub_data);
            this.formData.triphalaSachets = subData.triphalaSachets || null;
            this.isTriphalaSachetsDisabled=!!fieldValue;
            this.hasTriphalaSachetsData=!!fieldValue;
            this.formData.triphalaQuantity = subData.triphalaQuantity || null;
            this.isTriphalaQuantityDisabled=!!fieldValue;
            this.hasTriphalaQuantityData=!!fieldValue;
            this.formData.triphalaBatchNumber = subData.triphalaBatchNumber || null;
            this.isTriphalaBatchDisabled=!!fieldValue;
            this.hasTriphalaBatchData=!!fieldValue;
            this.formData.triphalaExpiryDate =
              subData.triphalaExpiryDate || null;
              this.isTriphalaExpiryDisabled=!!fieldValue;
              this.hasTriphalaExpiryData=!!fieldValue;

          }
          break;
        case "iii. Yava Churna":
          if (item.sub_data) {
            let subData = JSON.parse(item.sub_data);
            this.formData.yavaChurnaSachets = subData.yavaChurnaSachets || null;
            this.isYavaSachetsDisabled=!!fieldValue;
            this.hasYavaSachetsData=!!fieldValue;
            this.formData.yavaChurnaQuantity =
              subData.yavaChurnaQuantity || null;
              this.isYavaQuantityDisabled=!!fieldValue;
              this.hasYavaQuantityData =!!fieldValue;
            this.formData.yavaChurnaBatchNumber =
              subData.yavaChurnaBatchNumber || null;
              this.isYavaBatchDisabled=!!fieldValue;
              this.hasYavaBatchData=!!fieldValue;
            this.formData.yavaChurnaExpiryDate =
              subData.yavaChurnaExpiryDate || null;
              this.hasYavaExpiryData=!!fieldValue;
              this.isYavaExpiryDisabled=!!fieldValue;
          }
          break;
        case "1. Was the dietary consumption guidelines document given to the subject":
          this.formData.dietaryGuidelines = fieldValue; // Map Yes/No value
this.isDietaryGuidelinesDisabled = !!fieldValue;
this.hasDiet2Data=!!fieldValue;
          if (fieldValue === "no" && item.sub_data) {
            try {
              this.formData.dietaryGuidelinesComments = JSON.parse(
                item.sub_data
              ); // Parse comment if available
            } catch (error) {
              console.error("Error parsing sub_data:", error);
              this.formData.dietaryGuidelinesComments = item.sub_data;
                // Fallback to raw value
            }
          }
          break;

        case "2. Was the lifestyle guidelines document given to the subject":
          this.formData.lifestyleGuidelines = fieldValue; // Map Yes/No value
this.isLifestyle2Disabled=!!fieldValue;
this.hasLifestyle2Data=!!fieldValue;
          if (fieldValue === "no" && item.sub_data) {
            try {
              this.formData.lifestyleGuidelinesComments = JSON.parse(
                item.sub_data
              ); // Parse comment if available
            } catch (error) {
              console.error("Error parsing sub_data:", error);
              this.formData.lifestyleGuidelinesComments = item.sub_data; // Fallback to raw value
            }
          }
          break;
      }
    });
  }
  editStudy() {
    // Open edit reason modal only if field already has a value
    if (this.fieldLabel === "1. Date of the Baseline Visit:") {
      this.isReasonModalOpen = true;
    } else if (this.fieldLabel === "2. Was the subject recruited") {
      this.isReasonModalOpen = true;
    } else if (
      this.fieldLabel === "1. Was the prakriti analysis done for the subject"
    ) {
      this.isReasonModalOpen = true;
    } else if (this.fieldLabel === "1. Was Vital Signs evaluation performed") {
      this.isReasonModalOpen = true;
    } else if (
      this.fieldLabel === "1. Was physical and systemic examination performed"
    ) {
      this.isReasonModalOpen = true;
    } else if (this.fieldLabel === "Date of Last Menstrual Period (LMP)") {
      this.isReasonModalOpen = true;
    } else if (this.fieldLabel === "Was Urine Pregnancy Test (UPT) done") {
      this.isReasonModalOpen = true;
    } else if (this.fieldLabel === "UPT Result") {
      this.isReasonModalOpen = true;
    } else if (
      this.fieldLabel === "1. Was Laboratory Investigation performed"
    ) {
      this.isReasonModalOpen = true;
    } else if (this.fieldLabel === "1. Weight:") {
      this.isReasonModalOpen = true;
    } else if (this.fieldLabel === "2. Height:") {
      this.isReasonModalOpen = true;
    } else if (
      this.fieldLabel === "3. Waist circumference (part of IDRS Assessment):"
    ) {
      this.isReasonModalOpen = true;
    } else if (
      this.fieldLabel === "4. Body Mass Index [BMI = Weight (kg)/ Height2 (m)]:"
    ) {
      this.isReasonModalOpen = true;
    } else if (
      this.fieldLabel ===
      "1. Was the Diet Assessment done using the 24-Hour Diet Recall Checklist"
    ) {
      this.isReasonModalOpen = true;
    } else if (
      this.fieldLabel ===
      "1. Was the Lifestyle Assessment done using the FANTASTIC Lifestyle Checklist"
    ) {
      this.isReasonModalOpen = true;
    } else if (this.fieldLabel === "1. Principal Investigator’s Signature:") {
      this.isReasonModalOpen = true;
    } else if (this.fieldLabel === "2. Date:") {
      this.isReasonModalOpen = true;
    } else if (
      this.fieldLabel ===
      "1. Did the subject experience any adverse event since last visit"
    ) {
      this.isReasonModalOpen = true;
    } else if (
      this.fieldLabel ===
      "2. Did the subject take any new or change in concomitant medications since last visit"
    ) {
      this.isReasonModalOpen = true;
    }
    else if (
      this.fieldLabel ===
      "1. ADT - Ayurveda Diet Therapy: Health drink - asana pānaka"
    ) {
      this.isReasonModalOpen = true;
    }
     else if (
      this.fieldLabel ===
      "2. ADT - Ayurveda Diet Therapy: Triphala tablets"
    ) {
      this.isReasonModalOpen = true;
    }
     else if(this.fieldLabel==="3. ADT - Ayurveda Diet Therapy: Dietary guidelines"){
    this.isReasonModalOpen = true; 
    }
    else if(this.fieldLabel==="1. Were all the Study Products dispensed to the subject as per protocol"){
    this.isReasonModalOpen = true; 
    }
       else if(this.fieldLabel==="2. Was the Product Consumption Guide given to the patient"){
    this.isReasonModalOpen = true; 
    }
         else if(this.fieldLabel==="3. Was the Daily Product Consumption Log given to the subject"){
    this.isReasonModalOpen = true; 
    }
        else if(this.fieldLabel==="4. Date of dispensing of the Study Products"){
    this.isReasonModalOpen = true; 
    }
      else if(this.fieldLabel==="1. Total Number of sachets/boxes dispensed in this visit:"){
    this.isReasonModalOpen = true; 
    }
     else if(this.fieldLabel==="2. Total Study Product quantity dispensed in this visit:"){
    this.isReasonModalOpen = true; 
    }
    else if(this.fieldLabel==="1. Was the dietary consumption guidelines document given to the subject"){
    this.isReasonModalOpen = true; 
    }
    else if(this.fieldLabel==="3. Batch Number:"){
    this.isReasonModalOpen = true; 
    }
     else if(this.fieldLabel==="4. Date of Expiry:"){
    this.isReasonModalOpen = true; 
    }
    
     else if(this.fieldLabel==="1. Total Number of sachets/boxes dispensed in this visit:"){
    this.isReasonModalOpen = true; 
    }
    else if(this.fieldLabel==="2. Total Study Product quantity dispensed in this visit:"){
    this.isReasonModalOpen = true; 
    }
    else if(this.fieldLabel==="3. Batch Number:"){
    this.isReasonModalOpen = true; 
    }
     else if(this.fieldLabel==="4. Date of Expiry:"){
    this.isReasonModalOpen = true; 
    }
      else if(this.fieldLabel==="1. Total Number of sachets/boxes dispensed in this visit:"){
    this.isReasonModalOpen = true; 
    }
      else if(this.fieldLabel==="2. Total Study Product quantity dispensed in this visit:"){
    this.isReasonModalOpen = true; 
    }
 else if(this.fieldLabel==="3. Batch Number:"){
    this.isReasonModalOpen = true; 
    }
     else if(this.fieldLabel==="4. Date of Expiry:"){
    this.isReasonModalOpen = true; 
    }

     else if(this.fieldLabel==="2. Was the lifestyle guidelines document given to the subject"){
    this.isReasonModalOpen = true; 
    }
    
    
    
    
    // else if (
    //   this.fieldLabel ===
    //     "Language of Informed Consent Form given to the patient:" &&
    //   this.formData.language
    // ) {
    //   this.isReasonModalOpen = true;
    // } else if (
    //   this.fieldLabel === "Date of Signing" &&
    //   this.formData.consentDate
    // ) {
    //   this.isReasonModalOpen = true;
    // } else if (
    //   this.fieldLabel === "Time of Signing" &&
    //   this.formData.consentTime
    // ) {
    //   this.isReasonModalOpen = true;
    // } else if (
    //   this.fieldLabel === "1. Date of Screening Visit:" &&
    //   this.formData.screeningDate1
    // ) {
    //   this.isReasonModalOpen = true;
    // } else if (this.fieldLabel === "1. Gender:" && this.formData.gender) {
    //   this.isReasonModalOpen = true;
    // } else if (
    //   this.fieldLabel === "2. Date of Birth (DD/MMM/YYYY):" &&
    //   this.formData.dateOfBirth
    // ) {
    //   this.isReasonModalOpen = true;
    // } else if (
    //   this.fieldLabel === "3. Age (Years & Months):" &&
    //   this.formData.age
    // ) {
    //   this.isReasonModalOpen = true;
    // } 
    else {
      // First time - no need to ask
      if (this.fieldLabel === "1. Date of the Baseline Visit:") {
        this.isBaselineDateDisabled = false;
      } else if (
        this.fieldLabel === "1. Was the prakriti analysis done for the subject"
      ) {
        this.isPrakritiAnalysisDisabled = false;
      } else if (this.fieldLabel === "2. Was the subject recruited") {
        this.isSubjectRecruitedDisabled = false;
      } else if (
        this.fieldLabel === "1. Was Vital Signs evaluation performed"
      ) {
        this.isVitalSignsDisabled = false;
      } else if (
        this.fieldLabel === "1. Was physical and systemic examination performed"
      ) {
        this.isPhysicalExamDisabled = false;
      } else if (this.fieldLabel === "Date of Last Menstrual Period (LMP)") {
        this.isLMPDateDisabled = false;
      } else if (this.fieldLabel === "Was Urine Pregnancy Test (UPT) done") {
        this.isUPTDoneDisabled = false;
      } else if (this.fieldLabel === "UPT Result") {
        this.isUPTResultDisabled = false;
      } else if (
        this.fieldLabel === "1. Was Laboratory Investigation performed"
      ) {
        this.isLabDisabled = false;
      } else if (this.fieldLabel === "1. Weight:") {
        this.isWeightDisabled = false;
      } else if (this.fieldLabel === "2. Height:") {
        this.isHeightDisabled = false;
      } else if (
        this.fieldLabel === "3. Waist circumference (part of IDRS Assessment):"
      ) {
        this.isWaistDisabled = false;
      } else if (
        this.fieldLabel ===
        "4. Body Mass Index [BMI = Weight (kg)/ Height2 (m)]:"
      ) {
        this.isBMIDisabled = false;
      } else if (
        this.fieldLabel ===
        "1. Was the Diet Assessment done using the 24-Hour Diet Recall Checklist"
      ) {
        this.isDietDisabled = false;
      } else if (
        this.fieldLabel ===
        "1. Was the Lifestyle Assessment done using the FANTASTIC Lifestyle Checklist"
      ) {
        this.isLifestyleDisabled = false;
      } else if (
        this.fieldLabel ===
        "1. Did the subject experience any adverse event since last visit"
      ) {
        this.isAdverseDisabled = false;
      } else if (
        this.fieldLabel ===
        "2. Did the subject take any new or change in concomitant medications since last visit"
      ) {
        this.isAdverseDisabled2 = false;
      } else if (this.fieldLabel === "1. Principal Investigator’s Signature:") {
        this.isSignatureDisabled = false;
      } else if (this.fieldLabel === "2. Date:") {
        this.isDateDisabled = false;
      } 
      else if (this.fieldLabel === "1. ADT - Ayurveda Diet Therapy: Health drink - asana pānaka") {
        this.isADT1Disabled = false;
      } 
      else if(this.fieldLabel==="2. ADT - Ayurveda Diet Therapy: Triphala tablet"){
         this.isADT2Disabled = false;
      }
       else if(this.fieldLabel==="3. ADT - Ayurveda Diet Therapy: Dietary guidelines"){
         this.isADT3Disabled = false;
      }
        else if(this.fieldLabel==="1. Were all the Study Products dispensed to the subject as per protocol"){
         this.isStudyProductsDisabled = false;
      }
       else if(this.fieldLabel==="2. Was the Product Consumption Guide given to the patient"){
         this.isProductConsumptionGuideDisabled = false;
      }
          else if(this.fieldLabel==="3. Was the Daily Product Consumption Log given to the subject"){
    this.isProductLogDisabled = false; 
    }
        else if(this.fieldLabel==="4. Date of dispensing of the Study Products"){
    this.isDispensingDateDisabled=false;
    }
     else if(this.fieldLabel==="1. Total Number of sachets/boxes dispensed in this visit:"){
    this.isAsanaSachetsDisabled=false; 
    }
    else if(this.fieldLabel==="2. Total Study Product quantity dispensed in this visit:"){
    this.isAsanaQuantityDisabled=false; 
    }
    else if(this.fieldLabel==="3. Batch Number:"){
    this.isAsanaBatchDisabled = false; 
    }

      else if(this.fieldLabel==="4. Date of Expiry:"){
    this.isAsanaExpiryDisabled=false; 
    }

     else if(this.fieldLabel==="1. Total Number of sachets/boxes dispensed in this visit:"){
    this.isTriphalaSachetsDisabled=false;
    }
    else if(this.fieldLabel==="2. Total Study Product quantity dispensed in this visit:"){
    this.isTriphalaQuantityDisabled=false; 
    }
     else if(this.fieldLabel==="3. Batch Number:"){
    this.isTriphalaBatchDisabled=false; 
    }
      else if(this.fieldLabel==="4. Date of Expiry:"){
    this.isTriphalaExpiryDisabled=false;
    }
      else if(this.fieldLabel==="1. Total Number of sachets/boxes dispensed in this visit:"){
    this.isYavaSachetsDisabled=false;
    }
     else if(this.fieldLabel==="1. Was the dietary consumption guidelines document given to the subject"){
    this.isDietaryGuidelinesDisabled = false; 
    }
          else if(this.fieldLabel==="2. Total Study Product quantity dispensed in this visit:"){
    this.isYavaQuantityDisabled=false; 
    }
     else if(this.fieldLabel==="3. Batch Number:"){
    this.isYavaBatchDisabled=false;
    }
         else if(this.fieldLabel==="4. Date of Expiry:"){
    this.isYavaExpiryDisabled=false;
    }
      // else if (this.fieldLabel === "Date of Signing") {
      //   this.isDatePickerDisabled = false;
      //  } 
          else if(this.fieldLabel==="2. Was the lifestyle guidelines document given to the subject"){
    this.isLifestyle2Disabled= false; 
    }
      //else if (this.fieldLabel === "Time of Signing") {
      //   this.isTimePickerDisabled = false;
      // } else if (this.fieldLabel === "1. Date of Screening Visit:") {
      //   this.isDatePickerDisabled2 = false;
      // } else if (this.fieldLabel === "1. Gender:") {
      //   this.isDatePickerDisabled2 = false;
      // } else if (this.fieldLabel === "2. Date of Birth (DD/MMM/YYYY):") {
      //   this.isGenderDisabled = false;
      // } else if (this.fieldLabel === "3. Age (Years & Months):") {
      //   this.isAgeDisabled = false;
      // }
    }
  }
  confirmEditReason() {
    if (!this.editReason.trim()) {
      alert("Please enter a reason before proceeding.");
      return;
    }
    if (this.fieldLabel === "1. Date of the Baseline Visit:") {
      this.isBaselineDateDisabled = false;
    } else if (this.fieldLabel === "2. Was the subject recruited") {
      this.isSubjectRecruitedDisabled = false;
    } else if (
      this.fieldLabel === "1. Was the prakriti analysis done for the subject"
    ) {
      this.isPrakritiAnalysisDisabled = false;
    } else if (this.fieldLabel === "1. Was Vital Signs evaluation performed") {
      this.isVitalSignsDisabled = false;
    } else if (
      this.fieldLabel === "1. Was physical and systemic examination performed"
    ) {
      this.isPhysicalExamDisabled = false;
    } else if (this.fieldLabel === "Date of Last Menstrual Period (LMP)") {
      this.isLMPDateDisabled = false;
    } else if (this.fieldLabel === "Was Urine Pregnancy Test (UPT) done") {
      this.isUPTDoneDisabled = false;
    } else if (this.fieldLabel === "UPT Result") {
      this.isUPTResultDisabled = false;
    } else if (
      this.fieldLabel === "1. Was Laboratory Investigation performed"
    ) {
      this.isLabDisabled = false;
    } else if (this.fieldLabel === "1. Weight:") {
      this.isWeightDisabled = false;
    } else if (this.fieldLabel === "2. Height:") {
      this.isHeightDisabled = false;
    } else if (
      this.fieldLabel === "3. Waist circumference (part of IDRS Assessment):"
    ) {
      this.isWaistDisabled = false;
    } else if (
      this.fieldLabel === "4. Body Mass Index [BMI = Weight (kg)/ Height2 (m)]:"
    ) {
      this.isBMIDisabled = false;
    } else if (
      this.fieldLabel ===
      "1. Was the Diet Assessment done using the 24-Hour Diet Recall Checklist"
    ) {
      this.isDietDisabled = false;
    } else if (
      this.fieldLabel ===
      "1. Was the Lifestyle Assessment done using the FANTASTIC Lifestyle Checklist"
    ) {
      this.isLifestyleDisabled = false;
    } else if (
      this.fieldLabel ===
      "1. Did the subject experience any adverse event since last visit"
    ) {
      this.isAdverseDisabled = false;
    } else if (
      this.fieldLabel ===
      "2. Did the subject take any new or change in concomitant medications since last visit"
    ) {
      this.isAdverseDisabled2 = false;
    } else if (this.fieldLabel === "1. Principal Investigator’s Signature:") {
      this.isSignatureDisabled = false;
    } else if (this.fieldLabel === "2. Date:") {
      this.isDateDisabled = false;
    } else if (this.fieldLabel === "1. ADT - Ayurveda Diet Therapy: Health drink - asana pānaka") {
        this.isADT1Disabled = false;
      } 
      else if(this.fieldLabel==="2. ADT - Ayurveda Diet Therapy: Triphala tablet"){
         this.isADT2Disabled = false;
      }
       else if(this.fieldLabel==="3. ADT - Ayurveda Diet Therapy: Dietary guidelines"){
         this.isADT3Disabled = false;
      }
        else if(this.fieldLabel==="1. Were all the Study Products dispensed to the subject as per protocol"){
         this.isStudyProductsDisabled = false;
      }
       else if(this.fieldLabel==="2. Was the Product Consumption Guide given to the patient"){
         this.isProductConsumptionGuideDisabled = false;
      }
            else if(this.fieldLabel==="3. Was the Daily Product Consumption Log given to the subject"){
    this.isProductLogDisabled = false; 
    }
       else if(this.fieldLabel==="4. Date of dispensing of the Study Products"){
    this.isDispensingDateDisabled=false;
    }
       else if(this.fieldLabel==="1. Total Number of sachets/boxes dispensed in this visit:"){
    this.isAsanaSachetsDisabled=false; 
    }
else if(this.fieldLabel==="2. Total Study Product quantity dispensed in this visit:"){
    this.isAsanaQuantityDisabled=false; 
    }

     else if(this.fieldLabel==="3. Batch Number:"){
    this.isAsanaBatchDisabled = false;
    }
       else if(this.fieldLabel==="4. Date of Expiry:"){
    this.isAsanaExpiryDisabled=false; 
    }
     else if(this.fieldLabel==="1. Total Number of sachets/boxes dispensed in this visit:"){
    this.isTriphalaSachetsDisabled=false;
    }
     else if(this.fieldLabel==="2. Total Study Product quantity dispensed in this visit:"){
    this.isTriphalaQuantityDisabled=false; 
    }
     else if(this.fieldLabel==="3. Batch Number:"){
    this.isTriphalaBatchDisabled=false; 
    }
        else if(this.fieldLabel==="4. Date of Expiry:"){
    this.isTriphalaExpiryDisabled=false;
    }
      else if(this.fieldLabel==="1. Total Number of sachets/boxes dispensed in this visit:"){
    this.isYavaSachetsDisabled=false;
    }
           else if(this.fieldLabel==="2. Total Study Product quantity dispensed in this visit:"){
    this.isYavaQuantityDisabled=false; 
    }
     else if(this.fieldLabel==="3. Batch Number:"){
    this.isYavaBatchDisabled=false;
    }
           else if(this.fieldLabel==="4. Date of Expiry:"){
    this.isYavaExpiryDisabled=false;
    }
  else if(this.fieldLabel==="1. Was the dietary consumption guidelines document given to the subject"){
    this.isDietaryGuidelinesDisabled = false; 
    }
         else if(this.fieldLabel==="2. Was the lifestyle guidelines document given to the subject"){
    this.isLifestyle2Disabled= false; 
    }
    
    
    // else if (this.fieldLabel === "Date of Signing") {
    //   this.isDatePickerDisabled = false;
    // } else if (this.fieldLabel === "Time of Signing") {
    //   this.isTimePickerDisabled = false;
    // } else if (this.fieldLabel === "1. Date of Screening Visit:") {
    //   this.isDatePickerDisabled2 = false;
    // } else if (this.fieldLabel === "1. Gender:") {
    //   this.isGenderDisabled = false;
    // } else if (this.fieldLabel === "2. Date of Birth (DD/MMM/YYYY):") {
    //   this.isDatePickerDisabled3 = false;
    // } else if (this.fieldLabel === "3. Age (Years & Months):") {
    //   this.isAgeDisabled = false;
    // }

    this.isReasonModalOpen = false;
  }
  cancelEditReason() {
    this.isReasonModalOpen = false;
    this.editReason = "";
  }

  formatTimeTo24Hour(time: string): string {
    const [hours, minutes] = time.split(":");
    return `${hours}:${minutes}`; // Ensures it's always in 24-hour format
  }

  handleUptResultChange(): void {
    if (this.formData.uptResult === "Positive") {
      alert(
        "As the UPT test is positive, kindly exclude the patient from the study."
      );
    }
  }
  convertTo24HourFormat(time: string): string {
    // Check if the time contains AM or PM (i.e., is in 12-hour format)
    if (
      time.toLowerCase().includes("am") ||
      time.toLowerCase().includes("pm")
    ) {
      let [timePart, modifier] = time.split(" "); // Split time and AM/PM
      let [hours, minutes] = timePart.split(":").map(Number);

      if (modifier.toLowerCase() === "pm" && hours !== 12) {
        hours += 12;
      } else if (modifier.toLowerCase() === "am" && hours === 12) {
        hours = 0;
      }

      // Ensure two-digit format (e.g., 09:05 instead of 9:5)
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;
    }

    // If the time is already in 24-hour format, return it as is
    return time;
  }

  updateScreeningFailure(event: any) {
    const reason = event.target.value;
    if (event.target.checked) {
      // Add the reason to the array if checked
      this.formData.screeningFailure.push(reason);
    } else {
      // Remove the reason from the array if unchecked
      const index = this.formData.screeningFailure.indexOf(reason);
      if (index > -1) {
        this.formData.screeningFailure.splice(index, 1);
      }
    }
  }

  //edit end
  navigateToConcomitantMedication(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(
        ["/folders/concomitant-medication/concomitant-medication-log"],
        {
          queryParams: { studyId: this.studyId, subjectId: this.subjectId },
        }
      );
    } else {
      console.error("Missing studyId or subjectId");
    }
  }
  navigateToAdverseEvents(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(["/folders/adverse-events/adverse-event-report"], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId },
      });
    } else {
      console.error("Missing studyId or subjectId");
    }
  }
  navigateToVitalSigns(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(["/folders/vital-signs/vital-signs"], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId },
      });
    } else {
      console.error("Missing studyId or subjectId");
    }
  }
  // handleUptResultChange(): void {
  //   if (this.formData.uptResult === 'Positive') {
  //     alert('As the UPT test is positive, kindly exclude the patient from the study.');
  //   }
  // }

  navigateToLaboratory(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(
        ["/folders/laboratory-investigation-log/laboratory-investigation-log"],
        {
          queryParams: { studyId: this.studyId, subjectId: this.subjectId },
        }
      );
    } else {
      console.error("Missing studyId or subjectId");
    }
  }

  navigateToPhysicalSystemic(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(["/folders/physical-systemic/physical-systemic"], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId },
      });
    } else {
      console.error("Missing studyId or subjectId");
    }
  }

  validateForm() {
    const weightPattern = /^\d{3}\.\d{2}$/; // 3 digits and 2 decimals for weight
    const heightPattern = /^\d{2}\.\d{2}$/; // 2 digits and 2 decimals for height
    const waistPattern = /^\d{3}\.\d{2}$/; // 3 digits and 2 decimals for waist circumference
    const asanaChurnaPattern = /^\d{3}$/; // 3 digits followed by 'g'
    const triphalaQuantityPattern = /^\d{3}$/; // 3 digits followed by 'g'
    const yavaChurnaQuantityPattern = /^\d{3}$/; // 3 digits followed by 'g'

    const {
      weight,
      height,
      waistCircumference,
      asanaChurnaQuantity,
      yavaChurnaQuantity,
      triphalaQuantity,
    } = this.formData;

    // Only validate fields if they are not empty
    if (weight && !weightPattern.test(weight)) {
      alert("Invalid weight format. Please enter in 000.00 kg format.");
      return;
    }

    if (height && !heightPattern.test(height)) {
      alert("Invalid height format. Please enter in 00.00 m format.");
      return;
    }

    if (waistCircumference && !waistPattern.test(waistCircumference)) {
      alert(
        "Invalid waist circumference format. Please enter in 000.00 cm format."
      );
      return;
    }

    // Validate the new asanaChurnaQuantity field using this.formData
    if (asanaChurnaQuantity && !asanaChurnaPattern.test(asanaChurnaQuantity)) {
      alert(
        "Invalid asanaChurnaQuantity format. Please enter in 123g format (3 digits)."
      );
      return;
    }
    // Validate the new asanaChurnaQuantity field using this.formData
    if (triphalaQuantity && !triphalaQuantityPattern.test(triphalaQuantity)) {
      alert(
        "Invalid triphalaQuantity format. Please enter in 123g format (3 digits)."
      );
      return;
    }
    // Validate the new asanaChurnaQuantity field using this.formData
    if (
      yavaChurnaQuantity &&
      !yavaChurnaQuantityPattern.test(yavaChurnaQuantity)
    ) {
      alert(
        "Invalid yavaChurnaQuantity  format. Please enter in 123g format (3 digits)."
      );
      return;
    }

    // If all are valid, submit the form
    this.submitForm();
  }

  submitForm() {
    if (
      this.formData.labInvestigation === "no" &&
      (!this.formData.labInvestigationComments ||
        this.formData.labInvestigationComments.trim() === "")
    ) {
      alert('Comments are required when "No" is selected.');
      return;
    }

    let questionAnswers: { [key: string]: any } = {};

    if (this.formName && this.questionMapping[this.formName]) {
      this.questionMapping[this.formName].forEach((mapping) => {
        let fieldKey = mapping.question; // Use question text as key

        if (this.formName === "baseline-record") {
          if (
            mapping.field === "recruited" &&
            this.formData.recruited === "yes"
          ) {
            questionAnswers[fieldKey] = {
              answer: "yes",
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
              value: {
                recruitmentNo: this.formData.recruitmentNo,
                recruitmentDate: this.formData.recruitmentDate,
              },
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else if (this.formName === "baseline-prakriti-analysis") {
          if (mapping.field === "prakritiAnalysis") {
            if (this.formData.prakritiAnalysis === "yes") {
              questionAnswers[mapping.question] = {
                answer: "yes",
                editReason: this.editReason || "",
                 reviewStatus: { ...this.reviewOptions },
                value: this.formData.prakritiType,
              };
            } else {
              questionAnswers[mapping.question] = {
                answer: "no",
                editReason: this.editReason || "",
                 reviewStatus: { ...this.reviewOptions },
                value: this.formData.prakritiComment,
              };
            }
          } else {
            // existing default logic
            questionAnswers[mapping.question] = this.formData[mapping.field];
          }
        } else if (this.formName === "baseline-vital-signs") {
          if (
            mapping.field === "vitalSigns" &&
            this.formData.vitalSigns === "no"
          ) {
            questionAnswers[fieldKey] = {
              answer: "no",
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
              value: this.formData.vitalSignsComments,
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else if (this.formName === "baseline-physical-exam") {
          if (
            mapping.field === "physicalExam" &&
            this.formData.physicalExam === "no"
          ) {
            questionAnswers[fieldKey] = {
              answer: "no",
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
              value: this.formData.physicalExamComments || "",
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else if (this.formName === "baseline-lab-investigation") {
          if (
            mapping.field === "labInvestigation" &&
            this.formData.labInvestigation === "no"
          ) {
            questionAnswers[fieldKey] = {
              answer: "no",
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
              value: this.formData.labInvestigationComments || "",
            };
          } else if (
            mapping.field === "labInvestigation" &&
            this.formData.labInvestigation === "yes"
          ) {
            questionAnswers[fieldKey] = {
              answer: "yes",
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
              value: this.formData.sampleCollectionDate || "",
            };
          }
        } else if (this.formName === "baseline-anthropometric-data") {
          questionAnswers[fieldKey] = this.formData[mapping.field];
        } else if (this.formName === "baseline-diet-assessment") {
          if (
            mapping.field === "dietAssessment" &&
            this.formData.dietAssessment === "no"
          ) {
            questionAnswers[fieldKey] = {
              answer: "no",
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
              value: this.formData.dietAssessmentComments || "",
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else if (this.formName === "baseline-lifestyle-assessment") {
          if (
            mapping.field === "lifestyleAssessment" &&
            this.formData.lifestyleAssessment === "no"
          ) {
            questionAnswers[fieldKey] = {
              answer: "no",
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
              value: this.formData.lifestyleAssessmentComments || "",
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else if (this.formName === "baseline-intervention-details") {
          this.questionMapping[this.formName].forEach((mapping) => {
            questionAnswers[mapping.question] = this.formData[mapping.field]
              ? "yes"
              : "no";
             // editReason: this.editReason || "";
              
          });
        } else if (this.formName === "baseline-product-dispensing") {
          if (
            [
              "studyProductsDispensed",
              "productConsumptionGuide",
              "dailyProductConsumptionLog",
              "studyProductsDispensingDate",
            ].includes(mapping.field)
          ) {
            questionAnswers[fieldKey] = {
              answer: this.formData[mapping.field],
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
              value: this.formData[`${mapping.field}Comments`] || "",
            };
          } else if (mapping.field === "asanaChurna") {
            questionAnswers[fieldKey] = {
              value: {
                sachets: this.formData[`${mapping.field}Sachets`],
                quantity: this.formData[`${mapping.field}Quantity`],
                batchNumber: this.formData[`${mapping.field}BatchNumber`],
                expiryDate: this.formData[`${mapping.field}ExpiryDate`],
              },
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
            };
          } else if (mapping.field === "triphalaTablet") {
            questionAnswers[fieldKey] = {
              value: {
                triphalaSachets: this.formData.triphalaSachets,
                triphalaQuantity: this.formData.triphalaQuantity,
                triphalaBatchNumber: this.formData.triphalaBatchNumber,
                triphalaExpiryDate: this.formData.triphalaExpiryDate,
              },
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
            };
          } else if (mapping.field === "yavaChurna") {
            questionAnswers[fieldKey] = {
              value: {
                yavaChurnaSachets: this.formData.yavaChurnaSachets,
                yavaChurnaQuantity: this.formData.yavaChurnaQuantity,
                yavaChurnaBatchNumber: this.formData.yavaChurnaBatchNumber,
                yavaChurnaExpiryDate: this.formData.yavaChurnaExpiryDate,
              },
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
            };
          } else if (mapping.field === "dietaryGuidelines") {
            questionAnswers[fieldKey] = {
              answer: this.formData.dietaryGuidelines, // Yes or No
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
              value:
                this.formData.dietaryGuidelines === "no"
                  ? this.formData.dietaryGuidelinesComments || ""
                  : "",
            };
          } else if (mapping.field === "lifestyleGuidelines") {
            questionAnswers[fieldKey] = {
              answer: this.formData.lifestyleGuidelines, // Yes or No
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
              value:
                this.formData.lifestyleGuidelines === "no"
                  ? this.formData.lifestyleGuidelinesComments || ""
                  : "",
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } // New forms: baseline-adverse-events and baseline-end-visit
        else if (this.formName === "baseline-adverse-events") {
          if (
            mapping.field === "adverseEvents" &&
            this.formData.adverseEvents === "no"
          ) {
            questionAnswers[fieldKey] = {
              answer: "no",
              editReason: this.editReason || "",
               reviewStatus: { ...this.reviewOptions },
              value: this.formData.adverseEventsComments || "",
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else if (this.formName === "baseline-end-visit") {
          questionAnswers[fieldKey] = this.formData[mapping.field];
        } else {
          questionAnswers[fieldKey] = this.formData[mapping.field];
        }
      });
    }

    const submittedData = {
      folderName: "baseline-visits",
      formName: this.formName,
      studyId: this.studyId,
      subjectId: this.subjectId,
      ...questionAnswers,
    };

    console.log("Form Submitted:", submittedData);

    this.apiService.insertFormData(submittedData).subscribe({
      next: (response) => {
        console.log("Response from API:", response);
        alert("Form Submitted Successfully!");
        // ✅ Disable calendar and clear edit reason after successful submission
        this.isBaselineDateDisabled=true;
        this.isSubjectRecruitedDisabled = true;
        this.isPrakritiAnalysisDisabled = true;
        this.isVitalSignsDisabled = true;
        this.isPhysicalExamDisabled = true;
        this.isLMPDateDisabled = true;
        this.isUPTDoneDisabled = true;
        this.isUPTResultDisabled = true;
        this.isLabDisabled = true;
        this.isWeightDisabled = true;
        this.isHeightDisabled = true;
        this.isWaistDisabled = true;
        this.isBMIDisabled = true;
        this.isDietDisabled = true;
        this.isLifestyleDisabled = true;
        this.isSignatureDisabled = true;
        this.isDateDisabled = true;
        this.isAdverseDisabled = true;
        this.isAdverseDisabled2 = true;
        this.isADT1Disabled=true;
         this.isADT2Disabled=true;
          this.isADT3Disabled=true;
        this.isStudyProductsDisabled=true;
        this.isProductConsumptionGuideDisabled=true;
        this.isProductLogDisabled=true;
        this.isDispensingDateDisabled=true;
        this.isAsanaSachetsDisabled=true;
        this.isAsanaQuantityDisabled=true;
        this.isAsanaBatchDisabled=true;
        this.isAsanaExpiryDisabled=true;
        this.isTriphalaSachetsDisabled=true;
        this.isTriphalaQuantityDisabled=true;
        this.isTriphalaBatchDisabled=true;
        this.isTriphalaExpiryDisabled=true;
        this.isYavaSachetsDisabled=true;
        this.isYavaQuantityDisabled=true;
        this.isYavaBatchDisabled=true;
        this.isYavaExpiryDisabled=true;
this.isLifestyle2Disabled=true;

        
        this.isDietaryGuidelinesDisabled=true;




      
        this.editReason = "";
      },
      error: (error) => {
        console.error("Error submitting form:", error);
        alert("Error submitting form. Please try again.");
      },
    });
  }

  insertFormData(submittedData: {
    folderName: string | null;
    formName: string | null;
    studyId: string | null;
    subjectId: string | null;
  }) {
    throw new Error("Method not implemented.");
  }
  goBack() {
    this.router.navigate(["/study-details", this.studyId]);
  }
  createField() {
    alert("Create Field Clicked!");
  }

  checkVitalSigns() {
    if (this.formData.vitalSigns === "no") {
      this.formData.vitalSignsComments = "";
    }
  }

  calculateBMI(): void {
    const weight = this.formData.weight;
    const height = this.formData.height;

    if (weight > 0 && height > 0) {
      this.formData.bmi = parseFloat((weight / (height * height)).toFixed(1));
    } else {
      this.formData.bmi = 0; // Default to 0 if values are invalid
    }
  }
        //new + import line to allow. closing of panel
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement)?.closest('.options-modal');
    if (!clickedInside) {
      this.isOptionsModalOpen = false;
    }
  }
}
